import { Component } from "react";

import Icon from "@bokio/designsystem/components/Icon/Icon";
import { mergeClassNames } from "@bokio/utils/classes";

import * as styles from "./table.scss";

interface TableExpanderButtonProps {
	activeTrigger: boolean;
	onClick: () => void;
	orientation?: "top";
}

class TableExpanderButton extends Component<TableExpanderButtonProps> {
	render() {
		const { activeTrigger, onClick, orientation } = this.props;
		const topStyle = orientation === "top";
		const iconStateClass = activeTrigger ? (topStyle ? styles.topTrigger : styles.bottomTrigger) : "";
		return (
			<button type="button" onClick={onClick} className={styles.expanderButton} data-testid="TableExpanderButton">
				<Icon name="down-open-big" size="18" className={mergeClassNames(styles.iconTrigger, iconStateClass)} />
			</button>
		);
	}
}

export default TableExpanderButton;
